/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AnalysisResultCategory
 */
export interface AnalysisResultCategory {
    /**
     * 
     * @type {string}
     * @memberof AnalysisResultCategory
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof AnalysisResultCategory
     */
    name: string;
}

/**
 * Check if a given object implements the AnalysisResultCategory interface.
 */
export function instanceOfAnalysisResultCategory(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "name" in value;

    return isInstance;
}

export function AnalysisResultCategoryFromJSON(json: any): AnalysisResultCategory {
    return AnalysisResultCategoryFromJSONTyped(json, false);
}

export function AnalysisResultCategoryFromJSONTyped(json: any, ignoreDiscriminator: boolean): AnalysisResultCategory {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
    };
}

export function AnalysisResultCategoryToJSON(value?: AnalysisResultCategory | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
    };
}

